// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.temperature_section_container__qvZFp {
    background-color: #FFFFFF;
    border-radius: 15px;
    box-shadow: 0 3px 18px 1px #00206B33, -1px 2px 3px -2px #00206B40;
    padding: 20px;
    font-family: Mulish, sans-serif;
    height: auto;
}

.temperature_section_heatmap__DivY3 {
    display: flex;
    justify-content: space-between;
    padding: 0 50px;
    margin-bottom: 30px;
}

.temperature_section_legend__ZTR5H {
    background-color: #F7F9FC;
    border-radius: 15px;
    padding: 20px 70px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.temperature_section_temperature__shfoP {
    width: 15px;
    height: 15px;
    border-radius: 3px;
    margin-right: 20px;
}

.temperature_section_map__MKrRp {
    position: relative;
}

.temperature_section_outerIndicator__7VIgy {
    width: 60px;
    height: 60px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 50%;
}

.temperature_section_indicator__L4XK\\+ {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.temperature_section_innerIndicator__uEemZ {
    width: 11px;
    height: 11px;
    border-radius: 50%;
}

.temperature_section_table__7flen tbody tr td {
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    padding: 6px 10px;
}

.temperature_section_table__7flen tbody tr:hover {
    background-color: #F0F2F7;
}

.temperature_section_table__7flen {
    background-color: #F7F9FC;
    border-radius: 15px;
    padding: 20px;
    text-align: left;
}

.temperature_section_table__7flen table {
    width: 100%;
    border-collapse: collapse;
}

.temperature_section_table__7flen thead {
    color: #B4C3E4;
}

.temperature_section_table__7flen tbody tr {
    border-top: 1px solid #B4C3E4;
}

.temperature_section_table__7flen tbody td:first-of-type {
    color: #E72D39;
    font-weight: 600;
}

.temperature_section_table__7flen tbody td:last-of-type {
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/screens/detail/components/sections/temperature_section/temperature_section.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iEAAiE;IACjE,aAAa;IACb,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".container {\n    background-color: #FFFFFF;\n    border-radius: 15px;\n    box-shadow: 0 3px 18px 1px #00206B33, -1px 2px 3px -2px #00206B40;\n    padding: 20px;\n    font-family: Mulish, sans-serif;\n    height: auto;\n}\n\n.heatmap {\n    display: flex;\n    justify-content: space-between;\n    padding: 0 50px;\n    margin-bottom: 30px;\n}\n\n.legend {\n    background-color: #F7F9FC;\n    border-radius: 15px;\n    padding: 20px 70px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.temperature {\n    width: 15px;\n    height: 15px;\n    border-radius: 3px;\n    margin-right: 20px;\n}\n\n.map {\n    position: relative;\n}\n\n.outerIndicator {\n    width: 60px;\n    height: 60px;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    border-radius: 50%;\n}\n\n.indicator {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n}\n\n.innerIndicator {\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n}\n\n.table tbody tr td {\n    user-select: none;\n    cursor: pointer;\n    padding: 6px 10px;\n}\n\n.table tbody tr:hover {\n    background-color: #F0F2F7;\n}\n\n.table {\n    background-color: #F7F9FC;\n    border-radius: 15px;\n    padding: 20px;\n    text-align: left;\n}\n\n.table table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.table thead {\n    color: #B4C3E4;\n}\n\n.table tbody tr {\n    border-top: 1px solid #B4C3E4;\n}\n\n.table tbody td:first-of-type {\n    color: #E72D39;\n    font-weight: 600;\n}\n\n.table tbody td:last-of-type {\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `temperature_section_container__qvZFp`,
	"heatmap": `temperature_section_heatmap__DivY3`,
	"legend": `temperature_section_legend__ZTR5H`,
	"temperature": `temperature_section_temperature__shfoP`,
	"map": `temperature_section_map__MKrRp`,
	"outerIndicator": `temperature_section_outerIndicator__7VIgy`,
	"indicator": `temperature_section_indicator__L4XK+`,
	"innerIndicator": `temperature_section_innerIndicator__uEemZ`,
	"table": `temperature_section_table__7flen`
};
export default ___CSS_LOADER_EXPORT___;
